export default "__VITE_ASSET__DzvmQU6r__"